import { useCreateFileMutation } from '../../graphql/mutations/generated/createFile';
import { useDeleteFileMutation } from '../../graphql/mutations/generated/deleteFile';
import { useUpdateFileMutation } from '../../graphql/mutations/generated/updateFile';

export default function useFileMutations() {
  const [, createFile] = useCreateFileMutation();
  const [, deleteFile] = useDeleteFileMutation();
  const [, updateFile] = useUpdateFileMutation();

  return {
    createFile,
    deleteFile,
    updateFile,
  };
}
